import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  DatePicker,
  Input
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";

const HolidayCalendarModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [oldState, setOldState] = useState({});
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, oldState}) => {
        setType(type)
        setModalName(modalName)
        setOldState(oldState)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          const temp = {
            ...oldState,
            holidayDate: oldState?.holidayDate && dayjs(oldState?.holidayDate),
          }
          form.setFieldsValue(temp);
        } else {
        }
      }else{
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const testFn = async () => {
    }

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const { holidayDate } = form.getFieldValue()
      const response = await http.post(flag ? api.holidayCalendarAdd : api.holidayCalendarUpdate, {
        ...form.getFieldValue(),
        holidayDate: holidayDate?.format('YYYY-MM-DD') || '',
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="30%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="stateCode"
              label="State Code"
              rules={[{ required: true, message: 'State Code is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {label: 'FEDERAL', value: 'FEDERAL'},
                  {label: 'CA', value: 'CA'},
                  {label: 'NV', value: 'NV'},
                ]}
              />
            </Form.Item>

            <Form.Item
              name="holidayDate"
              label="Holiday Date"
              rules={[{ required: true, message: 'Holiday Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

            <Form.Item
              name="holidayName"
              label="Holiday Name"
              rules={[{ required: true, message: 'Holiday Name is required!' }]}
            >
              <Input
                placeholder="Please input Holiday Name"
              />
            </Form.Item>

            <Form.Item
              name="isPaid"
              label="Paid Holiday"
              rules={[{ required: true, message: 'Paid Holiday is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {label: 'Yes', value: 1},
                  {label: 'No', value: 2},
                ]}
              />
            </Form.Item>

            <Form.Item
              name="enabled"
              label="Enabled"
              rules={[{ required: true, message: 'Enabled is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {label: 'Yes', value:1},
                  {label: 'No', value: 2},
                ]}
              />
            </Form.Item>

            <Form.Item
              name="remark"
              label="Remark"
            >
              <Input.TextArea
                placeholder="Please Input Pending Remark"
                autoSize={{ minRows: 3, maxRows: 10 }}
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>.
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default HolidayCalendarModal;